import { useSecureLinks } from "../../hooks/useSecureLinks";
import { HideSSR } from "../HideSSR";

export const WebAnalytics = () => {
  const secureLinks = useSecureLinks(true);
  if (!secureLinks.webAnalytics) return null;
  return (
    <HideSSR>
      {typeof document !== "undefined" && typeof window !== "undefined" && (
        <img
          height="1"
          width="1"
          alt=""
          src={`${secureLinks.webAnalytics}?r=${encodeURIComponent(
            document.referrer
          )}&u=${encodeURIComponent(
            window.location.href
          )}&m=GET&${window.location.search.substr(1)}`}
        />
      )}
    </HideSSR>
  );
};
